import EditableTD from "./EditableTD";

export default EditableTD;
